import { PropsWithChildren } from "react";

import { Text } from "./text";
import { TextProps } from "./text.types";

export const NonAccessibleText = (props: PropsWithChildren<TextProps>) => (
  <Text allowFontScaling={false} {...props} />
);
